import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import "./TeamSection.css";
import member1 from "../../assets/member1.png";
import member2 from "../../assets/member2.png";
import member3 from "../../assets/member3.png";
import member4 from "../../assets/member4.png";
import member5 from "../../assets/member5.png";

const TeamSection = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Rajnikant C Sheth",
      role: "Founder and Managing Partner",
      description: "",
      img: member1,
      socials: {
        linkedin: "https://www.linkedin.com/in/rajnikant-sheth",
        twitter: "https://twitter.com/rajnikant",
        instagram: "https://instagram.com/rajnikant",
        facebook: "https://facebook.com/rajnikant",
      },
    },
    {
      id: 2,
      name: "Karan R Sheth",
      role: "Managing Partner",
      description: "",
      img: member2,
      socials: {
        linkedin: "https://www.linkedin.com/in/karan-sheth",
        twitter: "https://twitter.com/karansheth",
        instagram: "https://instagram.com/karansheth",
        facebook: "https://facebook.com/karansheth",
      },
    },
    {
      id: 3,
      name: "Sagar R Sheth",
      role: "Managing Partner",
      description: "",
      img: member3,
      socials: {
        linkedin: "https://www.linkedin.com/in/sagar-sheth",
        twitter: "https://twitter.com/sagarsheth",
        instagram: "https://instagram.com/sagarsheth",
        facebook: "https://facebook.com/sagarsheth",
      },
    },
    {
      id: 4,
      name: "Ramesh T Patel",
      role: "Operations Head",
      description: "",
      img: member4,
      socials: {
        linkedin: "https://www.linkedin.com/in/ramesh-patel",
        twitter: "https://twitter.com/rameshpatel",
        instagram: "https://instagram.com/rameshpatel",
        facebook: "https://facebook.com/rameshpatel",
      },
    },
    {
      id: 5,
      name: "Neha Sharma",
      role: "Marketing Director",
      description: "",
      img: member5,
      socials: {
        linkedin: "https://www.linkedin.com/in/nehasharma",
        twitter: "https://twitter.com/nehasharma",
        instagram: "https://instagram.com/nehasharma",
        facebook: "https://facebook.com/nehasharma",
      },
    },
  ];

  return (
    <section className="custom-team-section">
      <div className="custom-team-header">
        <h5 className="custom-team-subtitle">Meet Our Experts</h5>
        <h2 className="custom-team-title">Our Dedicated Team Members</h2>
        <br/>
        <img src={require('../../assets/team.png')} alt="Divider" className="custom-team-divider" />
      </div>

      {/* <div className="custom-team-grid">
        {teamMembers.map((member) => (
          <div key={member.id} className="custom-team-card">
            <img
              src={member.img}
              alt={member.name}
              className="custom-team-image"
            />
            <div className="custom-team-info">
              <h3 className="custom-team-name">{member.name}</h3>
              <p className="custom-team-role">{member.role}</p>
              <p className="custom-team-description">{member.description}</p>
            </div>

            <div className="custom-team-icons">
              <a
                href={member.socials.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="custom-team-icons"
              >
                <FaLinkedin />
              </a>
              <a
                href={member.socials.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="custom-team-icons"
              >
                <FaTwitter />
              </a>
              <a
                href={member.socials.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="custom-team-icons"
              >
                <FaInstagram />
              </a>
              <a
                href={member.socials.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="custom-team-icons"
              >
                <FaFacebookF />
              </a>
            </div>
          </div>
        ))}
      </div> */}
    </section>
  );
};

export default TeamSection;
